<template>
  <div
    class="main-div"
    :style="getBgStyle"
  >
    <div class="container">
      <br>
      <img
        width="180px"
        src="../../assets/img/logo.png"
        alt="logo"
      >
      <div class="css-typing">
        <span class="loader" />
        <h3 class="title-text-style pt-2 pb-5">
          Track. Manage. Build.
        </h3>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'WelcomePage',

  data () {
    return {
      cardBgImg: require('@/assets/img/home-page-bg-image.jpg'),
    };
  },
  computed: {
    getBgStyle () {
      return `background-image: url(${this.cardBgImg});`;
    },
    gateDetails () {
      return this.$store.getters['projects/getGateDetails'];
    },
    orgDetails () {
      return this.$store.getters['projects/getOrgDetails'];
    },
  },
  mounted () {
    this.loadOnMount();
  },
  methods: {
    loadOnMount () {
      const siteId = this.$route.params.siteId;
      if (siteId !== undefined && siteId !== null) {
        localStorage.setItem('siteId', siteId);
        localStorage.setItem('scannedTime', new Date().getTime());
        this.$store.dispatch('projects/fetchProjectOrganization', {
          id: siteId,
        })
        .then(() => {
          localStorage.setItem('orgDetails', JSON.stringify(this.orgDetails));
          setTimeout(() => {
            this.$router.push({ name: 'GetStarted' });
          }, 3000);
        }).catch(() => {
          setTimeout(() => {
            this.$router.push({ name: 'GetStarted' });
          }, 3000);
        });
        return;
      }
      setTimeout(() => {
        this.$router.push({ name: 'GetStarted' });
      }, 4000);
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Days+One&display=swap');
.container {
  animation: fadeIn 2s;
  -webkit-animation: fadeIn 2s;
  -moz-animation: fadeIn 2s;
  -o-animation: fadeIn 2s;
  -ms-animation: fadeIn 2s;
  animation-fill-mode: forwards;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: auto;

}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.main-div {
  background: #000000;
  height: 100vh;
  overflow: hidden;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  box-shadow: inset 0 0 0 4000px rgba(0, 0, 0, 0.452) !important;
}
@media only screen and (max-width:480px) {
  .main-div {
    position: absolute;
  }
}
::-webkit-scrollbar {
  width: 0 !important;
}
.loader {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #FFF;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-bottom: 10px;
}
.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border-left: 4px solid #FF3D00;
  border-bottom: 4px solid transparent;
  animation: rotation 0.5s linear infinite reverse;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.title-text-style {
  font-family: "Days One", sans-serif;
  font-weight: lighter;
  text-transform: uppercase;
  opacity: .7;
}
h3 {
  background: -webkit-linear-gradient(25deg, #eee, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 10px;
  animation: type 1.5s steps(90) 1s 1 normal both;
  position: relative;
}
.css-typing  {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
@keyframes type {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes cursor {
  50% {
    border-color: transparent;
  }
}
</style>
